import React, { useEffect, useState } from "react";
import { Form, Input, Button, Spin, Typography } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import getDataById from "../../../hooks/admin/getDataById";

const { Title } = Typography;

const AdminEditCustomer = () => {
  const [form] = Form.useForm();
  const user = JSON.parse(localStorage.getItem("admin"));
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getById = async () => {
      try {
        const response = await getDataById("admin/getbyidcustomer", id);
        if (response.status_code === 200) {
          const { cust_fullname, cust_email, cust_phone } = response.data;
          form.setFieldsValue({
            cust_fullname,
            cust_email,
            cust_phone,
          });
        }
      } catch (err) {
        toast.error("Failed to fetch customer data");
      } finally {
        setLoading(false);
      }
    };
    getById();
  }, [id, form]);

  const onFinish = async (values) => {
    const payload = {
      ...values,
      cust_id: parseInt(id),
    };

    try {
      const res = await fetch(
        `${process.env.REACT_APP_APIURL}/admin/updatecustomer`,
        {
          method: "PATCH",
          body: JSON.stringify(payload),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      const response = await res.json();

      if (response?.status_code === 200) {
        toast.success("Customer updated successfully");
        navigate(-1);
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Error updating customer");
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="max-w-xl mx-auto bg-white p-6 shadow-sm border border-gray-200 rounded">
      <Title level={3} className="!mb-6 text-center">
        Edit Customer
      </Title>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        className="space-y-4"
      >
        <Form.Item
          name="cust_fullname"
          label="Customer Name"
          rules={[{ required: true, message: "Please enter customer name" }]}
        >
          <Input placeholder="Enter full name" />
        </Form.Item>

        <Form.Item
          name="cust_email"
          label="Email"
          rules={[{ type: "email", message: "Invalid email" }]}
        >
          <Input placeholder="Enter email" />
        </Form.Item>

        <Form.Item
          name="cust_phone"
          label="Contact"
          rules={[
            {
              required: true,
              message: "Please enter contact number",
            },
          ]}
        >
          <Input type="number" placeholder="Enter contact number" />
        </Form.Item>

        <div className="flex justify-between pt-2">
          <Link to="/admin/customers">
            <Button danger>Cancel</Button>
          </Link>
          <button type="submit" className="btn btn-primary btn-sm text-white">
            Save
          </button>
        </div>
      </Form>
    </div>
  );
};

export default AdminEditCustomer;

